import React from 'react'
import TeamBusinessContainer from '../../Component/TeamOverview/TeamBusiness/TeamBusiness'
const MyTeamBusiness = () => {
  return (
    <div className='page-body'>
       <TeamBusinessContainer/>
    </div>
   
  )
}

export default MyTeamBusiness